import React from 'react'
import PropTypes from 'prop-types'

class VariantCol extends React.PureComponent {

    _renderBrandName = () => {
        const {brandName} = this.props

        return (
            <p className="brand-name">Brand Name: {brandName}</p>
        )
    }

    _handleFilterByClick = (name, value) => {
        const {onChangeFilter, filter} = this.props

        if (typeof onChangeFilter !== 'function') return;

        let newFilter = { ...filter }

        if (name === 'products.type') {
        newFilter[name] = [value]
        } else {
            newFilter[name] = value
        }

        onChangeFilter(newFilter)
    }

    render() {
        const {type, color, size, brandName} = this.props
        const brandNameHtml = this._renderBrandName()
        return (
            <div className="Variants">
                <p>Type: <span className='cursor-pointer hover-underline' onClick={() => this._handleFilterByClick('products.type', type)}>{type}</span></p>
                {
                    brandName ? brandNameHtml : ''
                }
                <p>Color: <span className='cursor-pointer hover-underline' onClick={() => this._handleFilterByClick('products.color', color)}>{color}</span></p>
                <p>Size: <span className='cursor-pointer hover-underline' onClick={() => this._handleFilterByClick('products.size', size)}>{size}</span></p>
            </div>
        )
    }
}

VariantCol.propTypes = {
    type: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
}

export default VariantCol